import { StaticImage } from "gatsby-plugin-image";
import * as Style from "./index.module.scss";

const PcPage: React.FC = () => {
  return (
    <div className={Style.PcPage}>
    </div>
  );
};

export default PcPage;
